import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/keepalive';

export const debug = createDebugger(prefix);
